import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=aaa3d528&scoped=true"
import script from "./Empresa.vue?vue&type=script&lang=js"
export * from "./Empresa.vue?vue&type=script&lang=js"
import style0 from "./Empresa.vue?vue&type=style&index=0&id=aaa3d528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa3d528",
  null
  
)

export default component.exports